import React from 'react';
import "./Signup.css";
import {useAuth} from "../Contexts/AuthContexts"
import { Link, useNavigate } from "react-router-dom";
function Login() {
    const navigate = useNavigate();
    const provider = useAuth();
    const eventsPage = () => {
      navigate("/UserHome")
    }

    const [formData, setFormData] = React.useState(
    {
        email: "",
        password: ""
    })

    const [improper, setImproper] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    function handleChange(event) {
      const {name, value, type, checked} = event.target
      setFormData(prevFormData => {
          return {
              ...prevFormData,
              [name]: type === "checkbox" ? checked : value
          }
      })
    }

    async function handleSubmit(event) {
      try {
        setLoading(true)
        event.preventDefault()
          await provider.login(formData.email, formData.password)
          eventsPage()
      } catch (err) {
        setImproper(JSON.stringify(err, Object.getOwnPropertyNames(err)))
       }
       setLoading(true)
    }


    return (
      <div className="form-container">
        <form className="form" onSubmit={handleSubmit}>
              <h1 className="font-semibold text-[35px] mb-[10px]">Log In</h1>
              <input className="form--input"
                  type="email"
                  placeholder="Email"
                  onChange={handleChange}
                  name="email"
                  value={formData.email}
              />
              <input className="form--input"
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  name="password"
                  value={formData.password}
              />
              <br />
              <br />
              {improper && <p>Error: Invalid credentials!</p>}
              <button disabled={loading} className="form--submit">Log In</button>
              <div className="mt-[10px]">
                  Need an account? <Link to="/signup" className="underline">Sign Up</Link>
              </div>
          </form>
        </div>
    )
  }
  
  export default Login;